export const dateProgress = (start: Date, end: Date) => {
  const now = new Date();
  const total = end.getTime() - start.getTime();
  const spent = Math.min(total, Math.max(0, now.getTime() - start.getTime()));
  return (spent / total) * 100;
};
